export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESSFUL = 'REGISTER_USER_SUCCESSFUL';
export const REGISTER_USER_FAILED = 'REGISTER_USER_FAILED';
export const REGISTER_COMPANY_ALREADY_EXIST = 'REGISTER_COMPANY_ALREADY_EXIST';
export const REGISTER_EMAIL_ALREADY_EXIST = 'REGISTER_EMAIL_ALREADY_EXIST';
export const REGISTER_IS_LOADING = 'REGISTER_IS_LOADING';


